import React from 'react';
import { useLocation } from 'react-router';
import { useUnviewedNotificationsCount } from 'services/CrmApi/queries/useUnviewedNotificationsCount';

interface IUnviewedNotificationsCountProps {
  showUnviewedNotificationsCount: boolean;
}

export const UnviewedNotificationsCount: React.FC<IUnviewedNotificationsCountProps> = ({
  showUnviewedNotificationsCount,
}) => {
  const location = useLocation();
  const notificationCountClassname =
    'inv-header-notifications-count text-black text-12px font-pt-sans font-normal min-w-[24px] max-w-[24px] max-h-[24px] min-h-[24px] flex items-center justify-center rounded-full bg-teal-20 absolute top-[-8px] left-[16px]';

  const { unviewedNotificationsCount, unviewedNotificationsCountQuery } = useUnviewedNotificationsCount(location.pathname);

  if (unviewedNotificationsCountQuery.isLoading) {
    return null;
  }

  if (unviewedNotificationsCount === 0) {
    return null;
  }

  return (
    <span className={notificationCountClassname}>
      {unviewedNotificationsCount < 99 ? unviewedNotificationsCount : '99+'}
    </span>
  );
};
